import React from 'react'
import styled from 'styled-components'
import { OverlayTrigger, Tooltip } from 'react-bootstrap/lib'

// Assets
import pdf from '../../../../../assets/images/pdf.png'

const DocumentItem = styled.div.attrs(() => ({
  className: 'mis-documentos-item'
}))`
  min-width: 0;
`

const TooltipTrigger = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-width: 0;
  flex: 1;
`

const DocumentTypeLabel = styled.span`
  display: block;
  align-self: stretch;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
`

export default function MyDocuments (props) {
  let listaDocumentos
  if (props.documents !== null) {
    listaDocumentos = props.documents.documents
    listaDocumentos = listaDocumentos.map((documento) => {
      return (
        <DocumentItem key={documento.id + documento.size}>
          <OverlayTrigger
            placement='top'
            delayShow={250}
            delayHide={100}
            overlay={
              <Tooltip id={`mis-documento-type-${documento.id}-${documento.size}`}>
                {documento.type}
              </Tooltip>
            }
          >
            <TooltipTrigger>
              <img src={pdf} className='img-responsive' alt='' />
              <DocumentTypeLabel>{documento.type}</DocumentTypeLabel>
            </TooltipTrigger>
          </OverlayTrigger>
        </DocumentItem>
      )
    })
  }
  return <div className='mis-docs-container'>{listaDocumentos}</div>
}
